<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">
        {{ $t("resetPassword") }}
      </p>
    </header>
    <section class="modal-card-body">
      <form ref="form">
        <div>
          <b-field v-if="!showInfo" :label="$t('email')" :type="emailError ? 'is-danger' : ''" :message="emailError">
            <b-input v-model="email" type="email" />
          </b-field>
          <p v-if="showInfo">
            {{ $t("pwResetInfo") }}
          </p>
        </div>
        <form />
      </form>
    </section>
    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        {{ $t("close") }}
      </button>
      <b-button v-if="!showInfo" class="button is-primary" :loading="isLoading" :disabled="!valid" @click="resetPW">
        {{ $t("reset") }}
      </b-button>
    </footer>
  </div>
</template>

<script>
import { auth } from "@/firebase";
export default {
  name: "PasswordResetModal",
  data() {
    return {
      dates: [],
      showInfo: false,
      isLoading: false,
      valid: false,
      email: "",
      emailError: "",
    };
  },
  watch: {
    email() {
      console.log("gzio");
      this.emailError = "";
      this.valid = this.$refs.form.checkValidity();
    },
  },
  methods: {
    async resetPW() {
      this.isLoading = true;
      try {
        await auth.sendPasswordResetEmail(this.email);
        this.$buefy.toast.open({
          type: "is-success",
          message: this.$t("resetPWMail"),
        });
        this.showInfo = true;
        this.email = "";
      } catch (err) {
        this.$buefy.toast.open({
          type: "is-danger",
          message: this.$t(err.code),
        });
      }
      this.isLoading = false;
    },
  },
};
</script>
